<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      <a-form-item style="margin: 0;float: right;">
        <a-button icon="plus" type="primary" primary @click="clickAdd()">添加</a-button>
      </a-form-item>
      <a-form-item>
        <a-input v-model="name" allowClear @pressEnter="init_data" placeholder="分组名|标识">
          <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
      <a-select v-model="status" style="width: 230px" @change="init_data" 
          placeholder="在职状态">
        <a-select-option value="">
          全部
        </a-select-option>
        <a-select-option value="1">
          正常
        </a-select-option>
        <a-select-option value="2">
          禁用
        </a-select-option>
      </a-select>
     </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData"
             style="background: #ffffff;" :loading="tableLoad" :rowKey="item=>item.id"
             bordered :pagination="false">

      <template slot="handle" slot-scope="text,recode">
        <a-button size="small" @click="clickEdit(recode)">编辑</a-button>
        <a-button type="primary" primary  size="small" @click="clickAuth(recode)">权限</a-button>
        <a-button type="primary" primary  size="small" @click="clickOldAuth(recode)">GB权限</a-button>
      </template>
      
    </a-table>
    
    <GroupAuthDialog
          :show-dialog="authDialogShow"
          :groupInfo="groupInfo"
          :menuList="menuList"
          :type="type"
          @close-dialog="closeDialog()"></GroupAuthDialog>
    <GroupEditDialog
          :show-dialog="editDialogShow"
          :groupInfo="groupInfo"
          :user-list="userlist"
          :groupList="groupList"
          @close-dialog="closeEditDialog()"></GroupEditDialog>
    <GroupAddDialog
          :show-dialog="addDialogShow"
          :user-list="userlist"
          :groupList="groupList"
          @close-dialog="closeAddDialog()"></GroupAddDialog>

    
  </div>
</template>

<script>
import {GetGroupTree} from "@/api/v1/group_api";
import {GetMenuAll,GetOldgbMenu} from "@/api/v1/menu_api";
import GroupAuthDialog from "@/components/V1/GroupAuthDialog";
import GroupEditDialog from "@/components/V1/GroupEditDialog";
import GroupAddDialog from "@/components/V1/GroupAddDialog";

export default {
  name: "UserGroup",
  components: {GroupAuthDialog,GroupEditDialog,GroupAddDialog},
  data(){
    return {
      name:'',
      status:'1',
      tableData:[],
      count:100,
      page:1,
      page_size:10,
      tableLoad:false,
      authDialogShow:false,
      editDialogShow:false,
      addDialogShow:false,
      groupInfo:{},
      type:'gb',
      userlist:[],
      menuList:[],
      groupList:[],
    }
  },
  mounted() {
    this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {title: '分组名', dataIndex: 'real_name',scopedSlots: { customRender: 'real_name' },},
        {title: '标识', dataIndex: 'name',scopedSlots: { customRender: 'name' },},
        {title: '操作', dataIndex: 'handle',scopedSlots: { customRender: 'handle' }},
      ]
      return _table_columns
    }
  },
  methods: {
    init_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetGroupTree({
        name:this.name,
        status:this.status,
        page:this.page,
        page_size:this.page_size
      }).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.tableData = resp.data
        }
      })
    },
    changePage(page,page_size){
      this.page = page
      this.page_size = page_size
      this.init_data()
    },
    closeDialog(){
      this.groupInfo = {}
      this.authDialogShow = false
      this.init_data()
    },
    closeEditDialog(){
      this.groupInfo = {}
      this.editDialogShow = false
      this.init_data()
    },
    clickEdit (groupInfo){
      GetGroupTree({}).then(resp => {
          if (resp.code===200){
            groupInfo.auth = []
            this.groupList = [{
              'id':'0',
              'real_name':"主菜单",
              'children':resp.data,
            }]
            groupInfo.status = groupInfo.status.toString()
            this.groupInfo = groupInfo
            this.editDialogShow = true
          }
      })
        
    },
    closeAddDialog(){
      this.addDialogShow = false
      this.init_data()
    },
    clickAdd (){
      this.groupInfo = {}
      GetGroupTree({}).then(resp => {
          if (resp.code===200){
            
            this.groupList = [{
              'id':"0",
              'real_name':"主菜单",
              'children':resp.data,
            }]
            this.addDialogShow = true
          }
      })
    },
    clickAuth(record){
      GetMenuAll({}).then(resp => {
        if (resp.code===200){
          this.menuList = resp.data
          if (record.auth) {
              record.auth = record.auth.split(',').map(item => {
              return item
            })
          } else {
            record.auth = [];
          }
          
          record.auth2 = this.filterArray(this.menuList, record.auth);
          record.auth = this.filterArray(this.menuList, record.auth);
          this.groupInfo = record
          this.type = 0
          this.authDialogShow = true
        }
      })
    },
    clickOldAuth(record){
      GetOldgbMenu({}).then(resp => {
        if (resp.code===200){
          this.menuList = resp.data
          let info
          info = record
          if (info.oldgb_auth) {
              info.auth = info.oldgb_auth.split(',').map(item => {
              return item
            })
          } else {
            info.auth = [];
          }
          
          info.auth2 = this.filterArray(this.menuList, info.auth);
          info.auth = this.filterArray(this.menuList, info.auth);
          this.groupInfo = info
          this.type = 'oldgb'
          this.authDialogShow = true
        }
      })
    },
    filterArray(menuList, resultArr)
    {
      let hasChild = []
      hasChild = this.getHashChild(menuList,hasChild);
      resultArr = resultArr.filter((item) => {
        let flag = hasChild.indexOf(item)
        if(flag == -1) {
            return item;
        }
      });
      return resultArr
    },
    getHashChild(dataList, array) {
      dataList.forEach(e => {
        if (e.children.length > 0) {
            array.push(e.id)
            array = this.getHashChild(e.children, array)
        }
      });
      return array
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/System/User/UserGroup.vue